var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-view"},[_c('Introduction'),_c('GraphSection'),_c('VideoUploadFormular'),_c('ClinicalApplicationTeam'),_c('MultimediaSection'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }